import { TargetedCatalogActionKeys as keys } from './targetedCatalogActionKeys';
import {
  ITargetedCatalogApiResponse,
  ITargetedCatalogGroup,
  ITargetedCatalogGroupNormalized,
  ITargetedCatalogItem,
  ITargetedCatalogSectionBase
} from './targetedCatalogInterfaces';

export const targetedCatalogActionCreators = {
  addItems: (payload: { preseasonCatalogItemGroupId: number; itemIds: string[] }) =>
    ({ payload, type: keys.ADD_TARGETED_CATALOG_ITEMS } as const),
  deleteItem: (catalogItemId: number) => ({
    payload: { catalogItemId },
    type: keys.DELETE_TARGETED_CATALOG_ITEM
  }),
  deleteItemGroup: (groupId: number) =>
    ({
      payload: { groupId },
      type: keys.DELETE_TARGETED_ITEM_GROUP
    } as const),
  deleteSection: (sectionId: number) =>
    ({
      payload: { sectionId },
      type: keys.DELETE_TARGETED_CATALOG_SECTION
    } as const),
  fetchCatalog: (payload: { brand?: string; full?: boolean }) =>
    ({
      payload,
      type: keys.FETCH_TARGETED_CATALOG
    } as const),
  itemSearch: (sectionId: number, searchTerm: string) =>
    ({
      payload: { sectionId, searchTerm },
      type: keys.TARGETED_CATALOG_ITEM_SEARCH
    } as const),
  removeItem: (catalogItemId: number) =>
    ({
      payload: { catalogItemId },
      type: keys.REMOVE_TARGETED_CATALOG_ITEM
    } as const),
  removeItemGroup: (groupId: number) =>
    ({
      payload: { groupId },
      type: keys.REMOVE_TARGETED_ITEM_GROUP
    } as const),
  removeSection: (sectionId: number) =>
    ({
      payload: { sectionId },
      type: keys.REMOVE_TARGETED_CATALOG_SECTION
    } as const),
  setCatalog: (payload: ITargetedCatalogApiResponse) =>
    ({
      payload,
      type: keys.SET_TARGETED_CATALOG
    } as const),
  setItemGroups: (payload: ITargetedCatalogGroup[]) =>
    ({
      payload,
      type: keys.SET_TARGETED_ITEM_GROUPS
    } as const),
  setItemSearchResults: (payload: { sectionId: number; searchTerm: string; itemIds: string[] }) =>
    ({
      payload,
      type: keys.SET_TARGETED_CATALOG_ITEM_SEARCH_RESULT
    } as const),
  setSectionMins: (payload: ITargetedCatalogSectionBase[]) =>
    ({ payload, type: keys.SET_TARGETED_CATALOG_SECTION_MIN } as const),
  setSelectedSection: (sectionId: number) =>
    ({ payload: { sectionId }, type: keys.SET_TARGETED_CATALOG_SELECTED_SECTION } as const),
  toggleItemSearch: () => ({ type: keys.TOGGLE_TARGETED_CATALOG_ITEM_SEARCH }),
  updateItemGroup: (payload: ITargetedCatalogGroupNormalized) =>
    ({
      payload,
      type: keys.UPDATE_TARGETED_ITEM_GROUP
    } as const),
  updateItemGroupOrder: (payload: Omit<ITargetedCatalogGroup, 'products'>) =>
    ({
      payload,
      type: keys.UPDATE_TARGETED_ITEM_GROUP_ORDER
    } as const),
  updateItemOrder: (payload: ITargetedCatalogItem) =>
    ({
      payload,
      type: keys.UPDATE_TARGETED_CATALOG_ITEM_ORDER
    } as const),
  updateSection: (payload: ITargetedCatalogSectionBase) => ({
    payload,
    type: keys.UPDATE_TARGETED_CATALOG_SECTION
  })
};
